import { apiFetch } from './client'
import type { PerpPosition } from '../types/perp'

export function fetchPerpPositions(portfolioId: string): Promise<PerpPosition[]> {
  return apiFetch<PerpPosition[]>(`/api/perps/${encodeURIComponent(portfolioId)}`)
}
